import React, { Component } from 'react';
import { connect } from 'react-redux';
import Cookies from 'universal-cookie';
import { withRouter } from 'react-router-dom';
import { signOut } from '../actions';

import SvgLogout from '../icons/svgLogout';

const cookies = new Cookies();

class Logout extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {handleLogout} = this.props;
    return (
      <div role="button" tabIndex={0} onKeyPress={handleLogout} onClick={handleLogout} className="dropdown-item">
        <SvgLogout />
        <p>Log Out</p>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user.user,
});

export default withRouter(connect(mapStateToProps)(Logout));
